import { AppConfig } from '../types';
import './string_extensions'
import { Strings } from '../assets/common/strings';

export const getResourceCenterCommissionStatementReportUrl = () => {
    const reportPath = AppConfig.resource_center_report_path.format(Strings.ResourceCenterReportPath.CommissionStatement);
    return `${AppConfig.resource_center_base_url}${Strings.ResourceCenterResourcePaths.Reports.format(reportPath, Strings.ResourceCenterReportName.CommissionStatement, 2, Strings.ResourceCenterReportList.FinancialReports)}`;
};
